import { render, staticRenderFns } from "./no-store.vue?vue&type=template&id=448d93b0&scoped=true&"
import script from "./no-store.vue?vue&type=script&lang=js&"
export * from "./no-store.vue?vue&type=script&lang=js&"
import style0 from "./no-store.vue?vue&type=style&index=0&id=448d93b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d93b0",
  null
  
)

export default component.exports